<template>
  <div>
    <label v-if="label" class="input-label" :style="{ paddingLeft: Object.keys($attrs).includes('prepend-icon') ? '42px' : '0px' }">
      {{ label }} <small v-if="showRequired" class="mt-6 error--text">*</small>
    </label>
    <v-text-field
      v-bind="$attrs"
      :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
      @click:append="showPassword = !showPassword"
      :type="showPassword ? 'text' : 'password'"
      :model-value="modelValue"
      @update:modelValue="valueChanged"
      @blur="blur"
    ></v-text-field>
  </div>
</template>

<script lang="ts">
import Vue, { defineComponent } from "vue";

export default defineComponent({
  inheritAttrs: false,
  props: {
    label: {
      type: String,
      required: false,
    },
    modelValue: {
      required: true,
    },
    showRequired: {
      type: Boolean,
      required: false,
    },
  },
  data() {
    return {
      showPassword: false,
    };
  },
  methods: {
    valueChanged(value: any) {
      this.$emit("update:modelValue", value);
    },
    blur() {
      this.$emit("blur");
    },
  },
  computed: {
    attrs(): any {
      return delete this.$attrs["label"];
    },
  },
});
</script>
